export default {
  data() {
    return {
      placeholderIndex: 0,
      currentPlaceholder: 'Search...',
      placeholderInterval: null,
      placeholderOptions: [
        'Search by customer',
        'orders: 000000',
        'orders: 000000,000000',
      ],
      placeholderIntervalDuration: 3000,
    };
  },

  mounted() {
    this.currentPlaceholder = this.placeholderOptions[0];

    this.placeholderInterval = setInterval(() => {
      this.placeholderIndex =
        (this.placeholderIndex + 1) % this.placeholderOptions.length; // Loop back to the start
      this.currentPlaceholder = this.placeholderOptions[this.placeholderIndex];
    }, this.placeholderIntervalDuration);
  },
  beforeDestroy() {
    if (this.placeholderInterval) {
      clearInterval(this.placeholderInterval);
    }
  },
};
